export default {
  tableName: "termsandconditions",

  attributes: {
    name: {
      type: "string",
      required: true,
    },

    dueDate: {
      type: 'ref',
      columnType: 'datetime'
    },

    version: {
      type: "string",
      required: true,
    },

    content: {
      type: "text",
      required: true,
    },

    type: {
      model: "termsandconditionstypes",
      required: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/TermsAndConditions.js